import React, { useState, useEffect } from 'react'
import {
  Panel,
  Form,
  Button,
  Table,
  IconButton,
  Icon,
  ButtonGroup,
  Row,
  Message,
  ControlLabel,
  Radio,
  RadioGroup,
  Uploader,
} from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import CustomIconMessageInfo from '../CustomIconMessageInfo'
import { startLoading, doneLoading } from '../../utils/loading'
import CancelProjectForm from './CancelProjectForm'
import ConfirmWidget from '../confirm/ConfirmWidget'
import {
  getCancelForm,
  updateCancel,
  getDownloadFileCancelNew,
} from '../../redux/actions/cancelOfProject'
import { useParams, useHistory } from 'react-router-dom'
import CancelProjectFileViewWidget from './CancelProjectFileViewWidget'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import pathname from '../../constants/pathname'
import { isRequired, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import classNames from 'classnames'
import { isEmpty } from 'lodash-es'
import AppContext from '../../context/AppContext'
import ErrorMessage from '../../../src/components/message/errorMessage/ErrorMessage'
import notification from '../../utils/notification'
import ApproverList from '../../components/modal/ApproverListModal/ApproverList'

export default function CancelProjectWidget({
  schema: _schema,
  isLawyer,
  attachmentSchema: _attachmentSchema,
  fileList,
  requestStep,
  hideUpload,
  isDirector,
  ...props
}) {
  const { showCommandButton, isEditAll } = props
  const [section, setSection] = useState()
  const [isEdit, setIsEdit] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [request, setRequest] = useState()
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [attachmentSchema, setAttachmentSchema] = useState(_attachmentSchema)
  const [isFileError, setIsFileError] = useState(false)
  const [submitData, setSubmitData] = useState()
  const [approveType, setApproveType] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()

  const { theme } = React.useContext(AppContext)

  const { Column, HeaderCell, Cell } = Table

  useEffect(() => {
    setIsEdit(isEditAll)
  }, [isEditAll])

  useEffect(() => {
    if (_attachmentSchema && fileList?.length > 0) {
      const newAttachmentSchema = _attachmentSchema.map((item) => {
        let data = item
        fileList.forEach((element) => {
          if (element.name == item.name) {
            data.path = element.path
          }
        })
        return data
      })
      setAttachmentSchema(newAttachmentSchema)
    }
  }, [_attachmentSchema, fileList])

  const handleCallService = async () => {
    setIsLoading(true)
    startLoading()
    setIsError(false)

    console.log('handleCallService')

    const formData = new FormData()

    Object.keys(submitData).forEach((key) => {
      if (key.indexOf('Attachment_') != -1) {
        console.log(key.indexOf('Attachment_'))

        if (submitData[key]) {
          submitData[key]?.forEach((element) => {
            formData.append(key, element.blobFile || null)
          })
        } else {
          formData.append(key, null)
        }
      }
    })

    formData.append('ProjectVersionId', projectId || '')
    formData.append('Value', submitData[formSchema.note.name] || '')
    formData.append('ApproveType', approveType ? approveType : 0)

    try {
      let response = await updateCancel(projectId, formData)

      if (response.success) {
        //success jump to new page
        setIsError(false)
        setIsShowConfirm(false)
        doneLoading()
        setIsLoading(false)
        // return history.push(`${pathname.proposal.overview.overviewCoworker}/${projectId}`)
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      } else {
        setIsError(response.message || response.errorMessage)
      }
    } catch (e) {
      console.log(e)
      setIsError(e?.response?.data?.errors?.Message || true)
    }
    setIsShowConfirm(false)
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    console.log('onSubmit', data)
    setSubmitData(data)
    setApproveType(data[formSchema?.approveType?.name || 'approvetype'])
    setIsShowConfirm(true)
  }

  const onConfirm = () => {
    console.log('onConfirm', request)
    handleCallService()
    setIsShowConfirm(false)
  }

  const onCancle = () => {
    console.log('onCancle')

    setRequest()
    setIsShowConfirm(false)
  }

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      var file = await getDownloadFileCancelNew(fileObj.path)
      var fileName = fileObj.label

      downloadFile(file, fileName)
      setIsFileError()
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
      //setIsFileError('ดาวน์โหลด')
    }
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      var file = await getDownloadFileCancelNew(fileObj.path)
      console.log(file)
      var fileName = fileObj.name

      previewFile(file, fileName)
      setIsFileError()
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'แสดง ไม่สำเร็จ ',
        duration: 5000,
      })
      //setIsFileError('แสดง')
    }
    doneLoading()
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      eventKey={2}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      {isFileError && (
        <Row style={{ marginBottom: 10 }}>
          <Message showIcon type="error" description={`${isFileError}ไม่สำเร็จ`} />
        </Row>
      )}
      {fileList && (
        <CancelProjectFileViewWidget
          data={fileList}
          onPreview={onPreview}
          onDownload={onDownload}
        />
      )}

      <CancelProjectForm
        schema={formSchema}
        attachmentSchema={attachmentSchema}
        register={register}
        Controller={Controller}
        control={control}
        errors={errors}
        setValue={setValue}
        clearErrors={clearErrors}
        hideUpload={
          hideUpload
            ? true
            : requestStep === 'Approved'
            ? false
            : isLawyer
            ? approveType != 2
            : false
        }
        isLoading={isLoading}
        onPreview={onPreview}
        onDownload={onDownload}
      />

      {formSchema.approveType && (
        <>
          <ErrorMessage error={errors[formSchema.approveType.name || 'approvetype']} />
          <Controller
            key={formSchema.approveType.name || 'approvetype'}
            name={formSchema.approveType.name || 'approvetype'}
            control={control}
            rules={isValidators(formSchema.approveType.validators)}
            defaultValue={formSchema.approveType.value}
            render={(props) => {
              return (
                <RadioGroup
                  value={props.value}
                  onChange={(value) => {
                    props.onChange(value)
                    setApproveType(value)
                  }}
                >
                  {formSchema.approveType?.options?.map((item) => {
                    return <Radio value={item.value}>{item.label} </Radio>
                  })}
                </RadioGroup>
              )
            }}
          />
        </>
      )}

      <hr />
      {isError && (
        <Message showIcon type="error" description={isError || formSchema.buttonText + `ไม่สำเร็จ `} />
      )}


      {isDirector &&
        <Button ripple appearance="ghost" onClick={handleSubmit(onSubmit)}>
          {formSchema.buttonText}
        </Button>
      }
      {!isDirector && (
        approveType == 2 ?
        <ApproverList
          approveType={10}
          projectversionId={projectId}
          style={{ marginLeft: 10, marginRight: 10 }}
          buttontext={'ตรวจสอบสายอนุมัติและ' + formSchema.buttonText}
          isLoading={isLoading}
          fetchButton={(disabled) =>
            <Button style={{marginBottom: 10}} disabled={disabled} ripple appearance="ghost" onClick={handleSubmit(onSubmit)}>
              {formSchema.buttonText}
            </Button>
          }
        />
        :
        <Button style={{marginBottom: 10}} ripple appearance="ghost" onClick={handleSubmit(onSubmit)}>
          {formSchema.buttonText}
        </Button>
      )}

      {/* {formSchema.buttonText2 && (
        <Button
          style={{ marginLeft: 15 }}
          ripple
          appearance="ghost"
          onClick={handleSubmit((e) => onSubmit(e, false))}
        >
          {formSchema.buttonText2}
        </Button>
      )} */}

      <ConfirmWidget
        title={`ยืนยันการ${formSchema.buttonText}`}
        show={isShowConfirm}
        detail={`กรุณายืนยันการ${formSchema.buttonText}`}
        onCancle={onCancle}
        onConfirm={onConfirm}
      />
    </Panel>
  )
}
